export default __webpack_public_path__ + "static/media/va.651e36eb.jpg";